/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum TokenStatus {
    OK = 1,
    INVALID = 2,
    EXPIRED = 3,
    REFRESH = 4
}

export enum TokenOptions {
    INTERVAL = 10
}
